import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-16" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mb-16" }
const _hoisted_4 = { class: "d-flex table-responsive" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "fit" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_8 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_9 = { class: "h5 title text-primary mb-48" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_checkbox = _resolveComponent("v-form-group-input-checkbox")!
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_form_row = _resolveComponent("v-form-row")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.fastAccessElementsLoaded)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fastAccessElements[_ctx.formName], (fastAccessElement) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-3",
                key: fastAccessElement.value
              }, [
                _createVNode(_component_v_form_group_input_checkbox, {
                  "for-key": fastAccessElement.value,
                  label: fastAccessElement.label,
                  variant: "category",
                  disabled: !_ctx.canCreateOrUpdateFormGroup,
                  class: "form-check-inline text-nowrap",
                  "label-class": "text-nowrap",
                  value: fastAccessElement.isChecked,
                  "aria-checked": fastAccessElement.isChecked,
                  "onUpdate:value": ($event: any) => (_ctx.fastAccessElementSelected($event, _ctx.formName, fastAccessElement.value,
          fastAccessElement.field))
                }, null, 8, ["for-key", "label", "disabled", "value", "aria-checked", "onUpdate:value"])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_table, { class: "table-bordered tableInput" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table_header, null, {
              default: _withCtx(() => [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastFormStructure.form_groups, (structureFormGroup, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(structureFormGroup.form_values, (structureFormValue, index) => {
                        return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(_ctx.$t(structureFormValue.label)), 1))
                      }), 128))
                    ], 64))
                  }), 128)),
                  _hoisted_5
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_table_body, null, {
              default: _withCtx(() => [
                (!_ctx.formData || !_ctx.formData.formGroups.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('No hay datos de esta categoría')), 1),
                          (_ctx.can('professional.expedient.form.store'))
                            ? (_openBlock(), _createBlock(_component_v_button, {
                                key: 0,
                                variant: "secondary",
                                class: "btn-icon me-16",
                                "aria-label": _ctx.$t('Añadir nueva {nombre}', { nombre: _ctx.$t(_ctx.formName) }),
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-form-create-modal')))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir nueva {nombre}', { nombre: _ctx.$t(_ctx.formName) })), 1)
                                ]),
                                _: 1
                              }, 8, ["aria-label"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.formData.formGroups, (formGroup, index) => {
                      return (_openBlock(), _createBlock(_component_v_form_row, {
                        "input-class": _ctx.inputClass,
                        "form-type": _ctx.formName,
                        "form-structure": _ctx.lastFormStructure,
                        "form-group": formGroup,
                        "form-id": _ctx.formData.id,
                        "force-save": _ctx.forceSave,
                        "action-buttons": { type: 'button', icon: 'done', value: '' },
                        onDeleteFormGroupRequest: _ctx.confirmDeleteFormGroup,
                        onEmitLoadFormsRequested: _ctx.emitLoadExpedientFormsRequestEvent,
                        key: index
                      }, null, 8, ["input-class", "form-type", "form-structure", "form-group", "form-id", "force-save", "onDeleteFormGroupRequest", "onEmitLoadFormsRequested"]))
                    }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}